<template>
    <div class="footer">
        <div class="footer-content">            
            <p>Copyright © 2015 - 2019 {{this.$t("Footer_Copyright_Countent")}}.</p>
            <p style="display:flex;align-items: center; justify-content: center;">
            备案号：
            <a href="https://beian.miit.gov.cn" target="_blank" style="text-decoration: underline;">粤ICP备15027527号</a>
            <a href="http://szcert.ebs.org.cn/d1b55140-68c8-4f10-9fe6-9afd61eb15d9" target="_blank">
            <img src="../assets/govIcon.png" title="深圳市市场监督管理局企业主体身份公示" alt="深圳市市场监督管理局企业主体身份公示" style="max-height: 35px;border-width:0px;border:hidden; border:none;"/>
            </a>
            </p>
        </div>
    </div>
</template>


<script>
export default {
  name: 'FooterComponent'
}
</script>

<style>
.footer{
    width: 100%;
    height: 120px;
    background-color: #ffffff;
}
.footer-content{
    padding-top: 30px;
    text-align: center;
}
</style>
